import { HttpLink } from 'apollo-link-http';
import { hasuraEndpoint } from '../../config';

const httpLink = new HttpLink({
  headers: { 'Content-Type': 'application/json' },
  uri: hasuraEndpoint,
});

export default httpLink;
